var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-tile",class:_vm.className},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":`Cover image for ${_vm.title}`}}),_c('h3',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }